import { useQuery } from "@tanstack/react-query";
import { GET_DIRECT_REPORTS } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseItem } from "api/types";
import { IReturnType } from "hooks/types";
import { useSnackbar } from "hooks/useSnackbar";
import { IUser } from "models/Employee";

export const useGetDirectReports = () => {
  const { showSnackbar } = useSnackbar();

  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  }:IReturnType<ApiResponseItem<IUser[]>> = useQuery([GET_DIRECT_REPORTS], () => fetchApi(`reports/users`).get(""), {
    onSuccess: (data) => {
      showSnackbar("Direct Reports Fetched Successfully", "success");
    },
    onError: (error) => {
      showSnackbar("Failed to Retrieve Direct Reports", "error");
    },
  });

  const directReports = response?.data?.items || [];

  return { directReports, isLoading, isError, isFetching, isSuccess, refetch };
};
